import {
  AfterViewChecked,
  AfterViewInit,
  Directive,
  ElementRef,
  Host,
  Input,
  OnInit,
  Optional,
  Renderer2
} from "@angular/core";
import {NgModel} from "@angular/forms";

@Directive({
  selector: '[formDisabled]'
})
export class FormDisabledDirective implements OnInit, AfterViewInit, AfterViewChecked {

  @Input("disabledOptions") options: { native?: boolean, bindLabel?: string, value?: string, preview?: boolean };
  private readonlyElement: any;

  constructor(private elementRef: ElementRef, @Host() @Optional() private ngModel: NgModel, private renderer: Renderer2) {

  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {

  }

  ngAfterViewChecked(): void {
    if (!this.options?.preview) {
      if (this.elementRef.nativeElement.disabled) {
        this.disableInput();
        this.removeUiRequired();
        let fieldsetParentList = document.querySelectorAll(`fieldset[disabled] label[for="${this.elementRef.nativeElement.id}"]`);
        if (fieldsetParentList?.length) {
          this.disableInput();
        }
      } else if (!this.options?.native) {
        this.removeReadonlyElement();
        this.createFormControlPlainTextElement();
        this.hideHostElement();
        this.removeUiRequired();
      } else {
        this.enableInput();
        this.addUiRequired();
        this.checkIfParentFieldsetDisabled();
      }
    }
  }

  private disableInput() {
    this.renderer.removeClass(this.elementRef.nativeElement, 'form-control');
    this.renderer.addClass(this.elementRef.nativeElement, 'form-control-plaintext');
    this.renderer.addClass(this.elementRef.nativeElement, 'form-disabled');
    this.renderer.setAttribute(this.elementRef.nativeElement, 'readonly', '');
  }

  private removeUiRequired() {
    document.querySelectorAll(`label[for="${this.elementRef.nativeElement.id}"]`)
      .forEach(label => {
        this.renderer.removeClass(label, 'ui-require');
      });
  }

  private addUiRequired() {
    document.querySelectorAll(`label[for="${this.elementRef.nativeElement.id}"]`)
      .forEach(label => {
        this.renderer.addClass(label, 'ui-require');
      });
  }

  private enableInput() {
    if (this.options?.native) {
      this.renderer.addClass(this.elementRef.nativeElement, 'form-control');
      this.renderer.removeClass(this.elementRef.nativeElement, 'form-control-plaintext');
      this.renderer.removeClass(this.elementRef.nativeElement, 'form-disabled');
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'readonly', '');
    } else {
      this.showHostElement();
      this.removeReadonlyElement();
    }
  }

  private checkIfParentFieldsetDisabled() {
    let fieldsetParentList = document.querySelectorAll(`fieldset[disabled] label[for="${this.elementRef.nativeElement.id}"]`);
    if (fieldsetParentList?.length) {
      if (this.options?.native) {
        this.renderer.removeClass(this.elementRef.nativeElement, 'form-control');
        this.renderer.addClass(this.elementRef.nativeElement, 'form-control-plaintext');
        this.renderer.addClass(this.elementRef.nativeElement, 'form-disabled');
        this.renderer.setAttribute(this.elementRef.nativeElement, 'readonly', '');
      } else {
        this.removeReadonlyElement();
        this.createFormControlPlainTextElement();
        this.hideHostElement();
      }
      this.removeUiRequired();
    }
  }

  private hideHostElement() {
    this.renderer.setAttribute(this.elementRef.nativeElement, 'hidden', '');
  }

  private showHostElement() {
    this.renderer.removeAttribute(this.elementRef.nativeElement, 'hidden');
  }


  private createFormControlPlainTextElement() {
    this.readonlyElement = this.renderer.createElement("input");
    if (this.options?.bindLabel) {
      try {
        this.readonlyElement.value = this.ngModel?.model[this.options?.bindLabel] || '-';
      } catch (e) {
        //do nothing
      }
    } else if (this.options?.value) {
      try {
        this.readonlyElement.value = this.options?.value || '-';
      } catch (e) {
        //do nothing
      }
    } else {
      this.readonlyElement.value = this.ngModel?.model || '-';
    }
    this.renderer.addClass(this.readonlyElement, 'form-control-plaintext');
    this.renderer.addClass(this.readonlyElement, 'form-disabled');
    this.renderer.setAttribute(this.readonlyElement, 'readonly', '');
    this.renderer.insertBefore(this.elementRef.nativeElement?.parentElement, this.readonlyElement, this.elementRef.nativeElement?.parentElement?.firstChild);
  }

  private removeReadonlyElement() {
    if (this.readonlyElement) {
      this.renderer.removeChild(this.elementRef.nativeElement?.parentElement, this.readonlyElement);
    }
  }
}
